import { SystemUserRole } from "common/SystemUserRole";
import { TokenDecoded } from "models/login/login";
import { AppPermissions, DEFAULT_PERMISSIONS } from "models/permissions/permissions";
import { UserInfo } from "models/user/user";

export function computePermissions(
  userInfo: UserInfo | undefined,
  tokenDecoded: TokenDecoded
): AppPermissions {
  if (!userInfo) {
    return DEFAULT_PERMISSIONS;
  }

  const isExternal = userInfo.type === "External";
  const isInternal = !isExternal;
  const isAdmin = isInternal && userInfo.systemUserRole === SystemUserRole.Admin;
  const isSuperUser = isInternal && userInfo.systemUserRole === SystemUserRole.SuperUser;

  return {
    isExternal,
    isInternal,
    isAdmin,
    isSuperUser,
    canViewInboxAll: isInternal,
    canViewDeliveryUpload: isExternal,
    canViewDeliveryUploaded: isExternal,
    canViewDeliveryNew: isInternal,
    canViewDeliveryHandled: isInternal,
    canViewDocuments: isInternal,
    canViewCustomerSettings: isInternal,
    canViewAdminPanel: isAdmin,
    canViewWizard: isInternal,
    canViewAllCustomers: isAdmin,
    canViewInvoiceReport: tokenDecoded.hasAccessToInvoiceReport === "True",
  };
}
